"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSidebar = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var hooks_1 = require("../../hooks");
function ModalSidebar(props) {
    var position = props.position, style = props.style, children = props.children, rest = __rest(props, ["position", "style", "children"]);
    var _a = hooks_1.useModalContext(), scroll = _a.scroll, hasHeader = _a.hasHeader, setSectionState = _a.setSectionState;
    var _b = styles_1.useStyles(createStyles, position, scroll, hasHeader), classes = _b.classes, css = _b.css;
    react_1.useEffect(function () {
        if (position === 'left') {
            setSectionState('hasLeftSidebar', true);
            return function () { return setSectionState('hasLeftSidebar', false); };
        }
        if (position === 'right') {
            setSectionState('hasRightSidebar', true);
            return function () { return setSectionState('hasRightSidebar', false); };
        }
    }, [setSectionState, position]);
    return (react_1.default.createElement("div", __assign({ className: css(classes.sidebar, style) }, rest), children));
}
exports.ModalSidebar = ModalSidebar;
var createStyles = function (theme, position, scroll, hasHeader) { return ({
    sidebar: {
        background: theme.pallete.gray.c90,
        border: 0,
        borderLeft: position === 'right' && "1px solid " + theme.pallete.divider,
        borderRight: position === 'left' && "1px solid " + theme.pallete.divider,
        padding: '1rem',
        width: '300px',
        overflowY: scroll === 'body' ? 'auto' : 'initial',
        gridRow: hasHeader ? '2' : '1',
        gridColumn: position === 'left' ? '1' : '3',
    },
}); };
//# sourceMappingURL=ModalSidebar.js.map